import type { User } from "./types";

/**
 * The last signed-in user's profile, kept so the app can start without a network.
 *
 * Opening the app offline can't ask the server "who am I?" (GET /me). Without this the app would
 * take a failed request for "signed out" and bounce a user who is simply on a train to the login
 * page - which they could not complete offline. Their session cookie is still valid; only the
 * network is missing. Cleared on sign-out. Holds a profile, never credentials.
 */
const KEY = "ledger:last-user";

export function saveLastUser(user: User): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(user));
  } catch {
    /* storage disabled or full: the app then simply needs a network to start */
  }
}

export function loadLastUser(): User | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as User) : null;
  } catch {
    return null;
  }
}

export function clearLastUser(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nothing to do */
  }
}
